<template>
  <div class="container-xl">
    <div class="card col-lg-12">
      <div class="card-header justify-content-between">
        <div class="card-title">
          <span class="mr-2">{{ $route.name }} List</span>
        </div>
      </div>
      <div class="card-body">
        <!-- <div class="flex">
          <div class="w-1/3">
            <el-form ref="form" label-width="150px">
              <el-form-item label="Filter Type">
                <el-select @change="filter.search_keyword = ''" size="small" v-model="filter.search_by" class="mr-2 w-full">
                  <el-option v-for="(item, index) in search_options" :key="index" :value="item.value" :label="item.text"/>
                </el-select>
              </el-form-item>
              <el-form-item v-if="filter.search_by === 'company_id'" label="Company">
                <el-select @change="searchHandler" filterable remote :remote-method="getCompanyRequestor" size="small" v-model="filter.search_keyword" class="mr-2 w-full" placeholder="Select company">
                <el-select @change="searchHandler" filterable remote  size="small" v-model="filter.search_keyword" class="mr-2 w-full" placeholder="Select company">
                  <el-option v-for="(item, index) in company_list" :key="index" :value="item.value" :label="item.text"/>
                </el-select>
              </el-form-item>
              <el-form-item v-else label="MyBenefit Package"> 
                <el-select @change="searchHandler" size="small" v-model="filter.search_keyword" class="mr-2 w-full" placeholder="Select package">
                  <el-option v-for="(item, index) in package_list" :key="index" :value="item.value" :label="item.text"/>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="w-1/3">
            <el-form ref="form" label-width="150px">
              <el-form-item label="Approval Status">
                <el-select @change="searchHandler" size="small" v-model="filter.status_filter" class="mr-2 w-full">
                  <el-option v-for="(item, index) in status_options" :key="index" :value="item.value" :label="item.text"/>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-button type="info" @click="searchHandler" size="small"><font-awesome-icon icon="search"/> Search</el-button> -->
        <el-button @click="handlerBtnCreate" type="primary" size="small"><font-awesome-icon icon="building"/> Add MyBenefit</el-button>
      </div>
      <div class="table-resp6797i bv,mg.data">
        <table class="table card-table text-nowrap table-vcenter">
          <thead>
            <tr>
              <th>Feature Name</th>
              <th>Feature Version</th>
              <th>Status</th>
              <th>Is New</th>
              <th>Maintenance</th>
              <th>Is Coming</th>
              <th>Last Updated at</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in benefit_list_feature" :key="index">
              <td>{{ item.feature_name }}</td>
              <td>{{ item.feature_version }}</td>
              <td>
                <span class="tag" :class="item.feature_status_color">{{ item.feature_status_str }}</span>
              </td>
              <td>
                <span class="tag" :class="item.feature_is_new_color">{{ item.feature_is_new_str }}</span>
              </td>
              <td>
                <span class="tag" :class="item.feature_is_maintenance_color">{{ item.feature_is_maintenance_str }}</span>
              </td>
              <td>
                <span class="tag" :class="item.feature_is_coming_color">{{ item.feature_is_coming_str }}</span>
              </td>
              <td>{{ item.created_at }}</td>  
              <td>
                <button class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown">Actions</button>
                  <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow p-2" style="width: 200px">
                    <a class="dropdown-item btn-sm cursor-pointer" @click="handlerBtnEdit(item)">
                      <font-awesome-icon class="text-primary" :icon="['fas', 'pen']"/>&nbsp; Edit MyBen
                    </a>
                    <a class="dropdown-item btn-sm cursor-pointer" @click="handlerBtnStatus(item)">
                      <font-awesome-icon class="text-primary" :icon="['fas', 'pen']"/>&nbsp; Status MyBen
                    </a>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
        <el-empty v-if="total_rows == 0" description="No data found" :image="emptyStateImage"></el-empty>
      </div>
      <pagination
        :page="page"
        :per_page="per_page"
        :list="benefit_list_feature"
        :total_rows="total_rows"
        @pageChange="pageChangeHandler"/>
    </div>
     <!-- ADD -->
    <b-modal size="lg" v-model="isShownModalMyBenefit" @reset="onHide" title="New Benefit" hide-footer @hide="onHide">
      <b-form  @submit.prevent="onSubmit" @reset="onHide" v-loading="loading.detail">
        <b-form-group label="Feature Name">
          <b-input v-model="form.feature_name" placeholder="Input Name" type="text" />
        </b-form-group>
       <b-form-group label="Feature Asset">
          <b-form-file
            v-model="form.feature_asset"
            :state="Boolean(form.feature_asset)"
            class="mt-2 border-1 p-2"
            accept=".png, .jpg, .jpeg"
            @input="onChangeFile($event, 'feature_asset')"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <small class="text-warning"
            ><i>*Submit an image before creating a myben</i></small
          ><br />
          <el-button @click="uploadImage" type="" size="small" plain round>
            Submit Image
          </el-button>
        </b-form-group>
        <b-form-group label="Feature Color">
          <el-select class="w-full" v-model="form.feature_color" placeholder="Select Color">
              <el-option v-for="(item, index) in status_color_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Deeplink">
          <b-input v-model="form.feature_deeplink" placeholder="Input Deeplink" type="text" />
        </b-form-group>
        <b-form-group label="Is New">
          <el-select class="w-full" v-model="form.feature_is_new" placeholder="is new?">
            <el-option v-for="(item, index) in feature_is_new_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Is Maintenance">
            <el-select class="w-full" v-model="form.feature_is_maintenance" placeholder="Select maintenance">
            <el-option v-for="(item, index) in feature_is_maintenance_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
         <b-form-group label="Is Coming Soon">
            <el-select class="w-full" v-model="form.feature_is_coming" placeholder="is coming?">
            <el-option v-for="(item, index) in feature_is_new_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Status">
          <el-select class="w-full" v-model="form.feature_status" placeholder="Select Color">
            <el-option v-for="(item, index) in status_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Description">
          <b-input v-model="form.feature_description" placeholder="Input Description" type="text" />
        </b-form-group>
        <b-form-group label="Info">
          <b-input v-model="form.feature_info" placeholder="Input Info" type="text" />
        </b-form-group>
        <b-form-group label="TnC">
          <b-input v-model="form.feature_tnc" placeholder="Input TnC" type="text" />
        </b-form-group>
        <b-form-group label="Platform">
          <el-select class="w-full" v-model="form.feature_platform" placeholder="Select Platform">
            <el-option v-for="(item, index) in platform_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Sort Order">
            <el-select class="w-full" v-model="form.feature_sort_order" placeholder="Select Sort Order">
            <el-option v-for="(item, index) in feature_sort_oder_option" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Category">
          <el-select class="w-full" v-model="form.feature_category" placeholder="Select Category">
            <el-option v-for="(item, index) in category_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Version">
          <el-select class="w-full" v-model="form.feature_version" placeholder="Select version">
            <el-option v-for="(item, index) in version_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <div class="d-flex flex-row float-right">
          <el-button @click="onSubmit" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
          <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
        </div>
      </b-form>
    </b-modal>
    <!-- EDIT -->
    <b-modal size="lg" v-model="isShownModalEdit" title="Edit My Benefit" hide-footer @hide="onHide">
      <b-form  @reset="onHide" @submit.prevent="doUpdate" v-loading="loading.detail">
        <b-form-group label="Feature Name">
          <b-input v-model="selected_item.feature_name" placeholder="Input Name" type="text" />
        </b-form-group>
          <b-form-group label="Feature Asset">
            <b-form-file
              v-model="form.feature_asset"
              :state="Boolean(form.feature_asset)"
              class="mt-2 border-1 p-2"
              accept=".png, .jpg, .jpeg"
              @input="onChangeFile($event, 'feature_asset')"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <small class="text-warning"
              ><i>*Submit an image before creating a myben</i></small
            ><br />
            <el-button @click="uploadImage" type="" size="small" plain round>
              Submit Image
            </el-button>
          </b-form-group>
          <b-form-group label="Current Image" v-if="selected_item.feature_asset">
            <img :src="selected_item.feature_asset" width="210"  hight="50" alt="Tabler" >
          </b-form-group>
        <b-form-group label="Feature Color">
          <el-select class="w-full" v-model="selected_item.feature_color" placeholder="Select Color">
              <el-option v-for="(item, index) in status_color_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Deeplink">
          <b-input v-model="selected_item.feature_deeplink" placeholder="Input Deeplink" type="text" />
        </b-form-group>
        <b-form-group label="Is New">
          <el-select class="w-full" v-model="selected_item.feature_is_new" placeholder="is new?">
            <el-option v-for="(item, index) in feature_is_new_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Is Maintenance">
            <el-select class="w-full" v-model="selected_item.feature_is_maintenance" placeholder="Select maintenance">
            <el-option v-for="(item, index) in feature_is_maintenance_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
         <b-form-group label="Is Coming Soon">
            <el-select class="w-full" v-model="selected_item.feature_is_coming" placeholder="is coming?">
            <el-option v-for="(item, index) in feature_is_new_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Status">
          <el-select class="w-full" v-model="selected_item.feature_status" placeholder="Select Color">
            <el-option v-for="(item, index) in status_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Description">
          <b-input v-model="selected_item.feature_description" placeholder="Input Description" type="text" />
        </b-form-group>
        <b-form-group label="Info">
          <b-input v-model="selected_item.feature_info" placeholder="Input Info" type="text" />
        </b-form-group>
        <b-form-group label="TnC">
          <b-input v-model="selected_item.feature_tnc" placeholder="Input TnC" type="text" />
        </b-form-group>
        <b-form-group label="Platform">
          <el-select class="w-full" v-model="selected_item.feature_platform" placeholder="Select Platform">
            <el-option v-for="(item, index) in platform_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Sort Order">
            <el-select class="w-full" v-model="selected_item.feature_sort_order" placeholder="Select Sort Order">
            <el-option v-for="(item, index) in feature_sort_oder_option" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Category">
          <el-select class="w-full" v-model="selected_item.feature_category" placeholder="Select Category">
            <el-option v-for="(item, index) in category_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <b-form-group label="Version">
          <el-select class="w-full" v-model="selected_item.feature_version" placeholder="Select version">
            <el-option v-for="(item, index) in version_feature_options" :key="index" :value="item.value" :label="item.text"/>
          </el-select>
        </b-form-group>
        <div class="d-flex flex-row float-right">
          <el-button @click="doUpdate" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
          <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
        </div>
      </b-form>
    </b-modal>
    <!-- EDIT STATUS -->
    <b-modal size="lg" v-model="isShownModalStatusEdit" :title="'Update Status #' + selected_item.feature_id" hide-footer @hide="onHide">
      <b-form @submit.prevent="doUpdateStatus" @reset="onHide" v-loading="loading.detail">
        <b-form-group label="Feature Name">
          <b-input
            v-model="selected_item.feature_name"
            disabled
            placeholder="Input feature name"
            type="text"/>
        </b-form-group>
        <b-form-group label="Status">
          <el-select class="mb-2" v-model="selected_item.feature_status" placeholder="Select Status feature" style="width: 100%">
            <el-option
              v-for="item in status_feature_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </b-form-group>
        <div class="d-flex flex-row float-right">
          <el-button @click="doUpdateStatus"  :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
          <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import emptyStateImage from '@/assets/images/undraw/empty-approval-history.svg';
import Pagination from '../../components/Pagination.vue';
import popupErrorMessages from '../../../library/popup-error-messages';
import { GET_MY_BENEFIT_LIST, CREATE_MYBEN, UPDATE_MY_BENEFIT_V2, UPDATE_STATUS_MYBENEFIT
} from '@/store/modules/companies';
import base64File from '@/library/base64File';
import imageCompress from '@/library/vue-image-compression';
import { UPLOAD_IMAGE } from "@/store/modules/channel";

export default {
  components: { Pagination },
  name: 'MyBenefitFeature',
  metaInfo: {
    title: 'MyBenefit Feat',
  },
  data() {
    return {
      isShownModalEdit: false,
      isShownModalStatusEdit: false,
      loading: {
        data: false,
        benefit_list_feature: false
      },
      emptyStateImage,
      total_rows: 0,
      list: [],
      isShownModalMyBenefit: false,
      page: 1,
      per_page: 20,
      benefit_list_feature: [],
      tempTarget: {},
      // target_list: [],
      selected_file: {
        file_image: null,
        file_image_base64: '',
      },
      selected_item: {
        image_url: '',
        file_image: null,
        file_image_base64: '',
      },
      image: null,
      image_base64: null,
      upload: {
        image: null,
      },
      file_tmp: "",
      form : {
        feature_name: '',
        image: null,
        // feature_asset: 'https://fastly.picsum.photos/id/21/600/200.jpg?hmac=vGZTc0ZN2Iz_A06wnsON4W1aW3LPFcB39ZG-6ojg_ws',
        feature_asset: '',
        feature_color: '',
        feature_deeplink: '',
        feature_is_new: '',
        feature_is_maintenance: '',
        feature_is_coming: '',
        feature_status: '',
        feature_description: '',
        feature_info: '',
        feature_tnc: '',
        feature_platform: '',
        feature_sort_order: '',
        feature_category: '',
        feature_version: '',
      },
      data_image: "",
      selected_item: {
        feature_name: '',
        // feature_asset: 'https://fastly.picsum.photos/id/21/600/200.jpg?hmac=vGZTc0ZN2Iz_A06wnsON4W1aW3LPFcB39ZG-6ojg_ws',
        feature_asset: '',
        feature_color: '',
        feature_deeplink: '',
        feature_is_new: '',
        feature_is_maintenance: '',
        feature_is_coming: '',
        feature_status: '',
        feature_description: '',
        feature_info: '',
        feature_tnc: '',
        feature_platform: '',
        feature_sort_order: '',
        feature_category: '',
        feature_version: '',
        feature_id: ''
      },
      filter: {
        search_by: 'company_id',
        search_keyword: '',
        status_filter: '',
      },
      search_options: [{
        text: 'Company',
        value: 'company_id',
      }, {
        text: 'MyBenefit Package',
        value: 'mybenefit_package_id',
      }],
      company_list: [{
        value: '', text: 'All',
      }],
      package_list: [{
        value: '', text: 'All',
      }],
      status_options: [
        { value: '', text: 'All' },
        { value: 'request', text: 'Waiting Approval' },
        { value: 'approved', text: 'Approved' },
        { value: 'rejected', text: 'Rejected' },
      ],
      status_color_options: [
        { value: 'gradientBlue', text: 'Gradient Blue' },
        { value: 'gradientYellow', text: 'Gradient Yellow ' },
        { value: 'gradientBlack', text: 'Gradient Black ' },
        { value: 'gradientPurple', text: 'Gradient Purple ' },
        { value: 'gradientGreen', text: 'Gradient Green' },
        { value: 'gradientRed', text: 'Gradient Red' },
        { value: 'gradientCyan', text: 'Gradient Cyan' },
        { value: 'transparent', text: 'Transparent ' },
      ],
      status_feature_options: [
        { value: 'inactive', text: 'Inactive' },
        { value: 'active', text: 'Active ' },
        { value: 'maintenance', text: 'Maintenance ' },
        { value: 'closed', text: 'Closed ' },
        // { value: 'is_coming', text: 'Coming Soon ' },
      ],
      platform_feature_options: [
        { value: 'both', text: 'Both' },
        { value: 'web', text: 'Web ' },
        { value: 'mobile', text: 'Mobile ' },
      ],
      category_feature_options: [
        { value: 'unnamed', text: 'Unnamed' },
        { value: 'product', text: 'Product ' },
        { value: 'tool', text: 'Tool ' },
      ],
      version_feature_options: [
        { value: 'v1', text: 'V1' },
        { value: 'v2', text: 'V2 ' },
      ],
      feature_is_maintenance_options : [
        { value: true, text: 'Active' },
        { value: false, text: 'Inactive ' },
      ],
      feature_is_new_options: [
        { value: true, text: 'True' },
        { value: false, text: 'False ' },
      ],
      feature_sort_oder_option: [
        { value: 1 , text: '1' },
        { value: 2 , text: '2 ' },
      ],
      timeout: {
        filter_company: null,
      },
    };
  },
  async mounted() {
    this.loadMyBenefitListRevamp();
  },
  computed: {
  },
  methods: {
    async uploadImage() {
      this.company_id = parseInt(this.company_id);
      try {
        const requestBody = {
          file_data: this.file_tmp,
          filename: "image-avatar",
          source: "vdashboard",
          product: "avatar",
          category: "system",
        };
        const response = await this.$store.dispatch(UPLOAD_IMAGE, {
          data: requestBody,
        });
        const { file_id, file_url } = response.data.rows;
        this.data_image = { file_id, file_url };
        localStorage.setItem("uploadedImage", JSON.stringify(this.data_image));
        this.file_tmp = "";
        this.$message({
          title: "Success",
          type: "success",
          message: "Upload success created",
        });

        this.getList();
      } catch (err) {
        console.error("Upload Image Error:", err.response?.data || err.message);
        popupErrorMessages(err.response?.data);
      }
    },
    async doUpdate() {
      this.$confirm(
        'You will update the myben. Make sure you have input the data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const storedImage = localStorage.getItem("uploadedImage");
              const uploadedImage = storedImage ? JSON.parse(storedImage) : null;
              const requestBody = {
                  feature_name: this.selected_item.feature_name, 
                  // feature_asset: this.selected_item.feature_asset,
                  feature_asset: uploadedImage?.file_url,
                  feature_color: this.selected_item.feature_color,
                  feature_deeplink: this.selected_item.feature_deeplink, 
                  feature_is_new: this.selected_item.feature_is_new,
                  feature_is_maintenance: this.selected_item.feature_is_maintenance,
                  feature_is_coming: this.selected_item.feature_is_coming,
                  feature_status: this.selected_item.feature_status,
                  feature_description: this.selected_item.feature_description,
                  feature_info:  this.selected_item.feature_info,
                  feature_tnc:  this.selected_item.feature_tnc,
                  feature_platform:  this.selected_item.feature_platform,
                  feature_sort_order:  this.selected_item.feature_sort_order,
                  feature_category:  this.selected_item.feature_category,
                  feature_version:  this.selected_item.feature_version,
              };
              const id = this.selected_item.feature_id;
              await this.$store.dispatch(UPDATE_MY_BENEFIT_V2, { id, data: requestBody })
                .then(() => {
                  this.$message({
                    title: 'Success',
                    type: 'success',
                    message: 'MyBenefit updated',
                  });
                  this.loadMyBenefitListRevamp();
                  this.onHide();
                }).catch((err) => {
                  popupErrorMessages(err.response.data);
                });
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    onHide() {
      this.isShownModalStatusEdit = false;
      this.isShownModalEdit = false;
      this.isShownModalMyBenefit = false;
    },
    handlerBtnStatus(item) {
      this.selected_item = item;
      this.isShownModalStatusEdit = true;
    },
    async doUpdateStatus() {
      this.$confirm(
        'You will update status of my benefit. Make sure you have input the data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const requestBody = {
                feature_status: this.selected_item.feature_status,
              };
              const id = this.selected_item.feature_id;
              try {
                const response = await this.$store.dispatch(UPDATE_STATUS_MYBENEFIT, {
                  id,
                  data: requestBody,
                });
                this.$message({
                  title: 'Success',
                  type: 'success',
                  message: 'Status MyBen updated',
                });
                this.loadMyBenefitListRevamp();
                this.onHide();
              } catch (err) {
                popupErrorMessages(err?.response?.data || err.message || 'Something went wrong');
              }
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    handlerBtnEdit(item) {
      this.selected_item = item;
      this.isShownModalEdit = true;
    },
    handlerBtnCreate() {
      this.isShownModalMyBenefit = true;
    },
    async loadMyBenefitListRevamp() {
      this.loading.benefit_list_feature = true;
      const response = await this.$store.dispatch(GET_MY_BENEFIT_LIST).catch((err) => {
        return null;
      });
      const rows = response?.data?.rows || [];
      const count = response?.data?.count || 0;
      this.total_rows = count;
      this.benefit_list_feature = rows;
      this.loading.benefit_list_feature = false;
    },
    async onChangeFile(event, target) {
      if (this.form[target]) {
        const compressed = await imageCompress(this.form[target]);
        this.form[`${target}_base64`] = await base64File(compressed);
        this.file_tmp = this.form[`${target}_base64`];
      }
    },
    async onSubmit() {
      const storedImage = localStorage.getItem("uploadedImage");
      const uploadedImage = storedImage ? JSON.parse(storedImage) : null;
      try {
        const requestBody = {
          feature_name: this.form.feature_name, 
          feature_asset: uploadedImage?.file_url,
          feature_color: this.form.feature_color,
          feature_deeplink: this.form.feature_deeplink, 
          feature_is_new: this.form.feature_is_new,
          feature_is_maintenance: this.form.feature_is_maintenance,
          feature_is_coming: this.form.feature_is_coming,
          feature_status: this.form.feature_status,
          feature_description: this.feature_description,
          feature_info:  this.form.feature_info,
          feature_tnc:  this.form.feature_tnc,
          feature_platform:  this.form.feature_platform,
          feature_sort_order:  this.form.feature_sort_order,
          feature_category:  this.form.feature_category,
          feature_version:  this.form.feature_version,
        };
        const response = await this.$store.dispatch(CREATE_MYBEN, requestBody );
        this.form.feature_name = '';
        this.form.feature_asset = '';
        this.form.feature_color = '';
        this.form.feature_deeplink = '';
        this.form.feature_is_new = '',
        this.form.feature_is_maintenance = '',
        this.form.feature_is_coming = ''
        this.form.feature_status = '',
        this.form.feature_description = '',
        this.form.feature_info = '',
        this.form.feature_tnc = '',
        this.form.feature_platform = '',
        this.form.feature_sort_order = '',
        this.form.feature_category = ''
        this.form.feature_version = ''
        this.benefit_list_feature = response;
        this.$message({
            title: 'Success',
            type: 'success',
            message: 'MyBenefit successfully created',
        });
        this.onHide();
        this.loadMyBenefitListRevamp();
      } catch (err) {
        popupErrorMessages(err.response.data);
      }
    },
    pageChangeHandler(value) {
      this.page = value;
      this.loadMyBenefitListRevamp();
    },
    searchHandler() {
      this.page = 1;
      this.getCompanyRequestor();
      this.loadMyBenefitListRevamp();
    },
  },
};
</script>
<style>
.tag-gold {
  background-color: #fcc200;
  color: #fff;
  font-weight: 600;
}
.tag-bronze {
  background-color: #CD7F32;
  color: #fff;
  font-weight: 600;
}
</style>
